import { createMedia } from "@tamagui/react-native-media-driver";

export const mediaQueries = createMedia({
  xs: { maxWidth: 660 },
  hubScreen: { maxWidth: 1920, maxHeight: 480 },
});
